module.exports = __webpack_public_path__ + "static/media/ico_pizarron.c9def033.png";